import pt from './pt.json';
import eng from './eng.json';

export function Lang(key, language = "pt") {
  switch(language.toLocaleLowerCase()) {
    case "pt":
      return pt[key];
    case "eng":
      return eng[key];
    default:
      return pt[key];
  }
};
